import { ProgramOptions } from "../api/models/program";


export interface Page{
    title: string;
    type: string;
    pageNumber:number;
    sheetNumber?: number;
    startIndex?: number;
    stopIndex?: number;
}


export function ProgramPageDefinition(numGames:number, numLeaders:number, numAthletes:number, programOptions:ProgramOptions): Page[] {

    const numFrontPage = 1;
    const numBackPage = 1;
    const numMVPPages = 1;
    const numAllStarPages = 1;
    const numVIPPages = 1;


    const numGamePages = Math.ceil(numGames / programOptions.gamesPerPage);
    const numRosterPages = Math.ceil(numAthletes / programOptions.membersPerPage);
    const numLeaderPages = Math.ceil(numLeaders / programOptions.membersPerPage);

    const minPageCount =  numGamePages + numRosterPages + numFrontPage + numBackPage + numMVPPages + numAllStarPages +numLeaderPages + numVIPPages + 4;
    const totalPageCount = Math.ceil(minPageCount / 4) * 4;
    let numSpecialPages = totalPageCount - minPageCount + 4;

    if(programOptions.hasExtraSheet){
        numSpecialPages = numSpecialPages + 4;
    }

    const totalSheets = totalPageCount / 2;

    console.log(`number of members: ${numAthletes}`);
    console.log(`number of leaders: ${numLeaders}`);

    console.log(`Total Pages: ${totalPageCount}`);
    console.log(`Front Page: 1`);
    console.log(`MVP: 1`);
    console.log(`Game Pages: ${numGamePages}`);
    console.log(`Roster Pages: ${numRosterPages}`);
    console.log(`Leader Pages: ${numLeaderPages}`);
    console.log(`Special Pages: ${numSpecialPages}`);
    console.log(`Sponsor Pages: ${numMVPPages + numAllStarPages + numVIPPages}`);
    console.log(`Back Page: 1`);

    console.log(`Total Sheets: ${totalSheets}`);

    let pageNumber = 1;

    const pages: Page[] = [];
    addPage(pages, 'Front', 'Front',pageNumber++);
    addPage(pages, 'MVP', 'MVP',pageNumber++);

    let itemIndex = 0;

    for (let i = 1; i <= numGamePages; i++) {
        addPage(pages, `Game Page ${i}`, 'Game',pageNumber++,itemIndex,itemIndex+7);
        itemIndex = itemIndex + 8;
    }

    itemIndex = 0;

    for (let i = 1; i <= numRosterPages; i++) {
        addPage(pages, `Roster Page ${i}`, 'Roster',pageNumber++,itemIndex,itemIndex+15);
        itemIndex = itemIndex + 16;
    }

    itemIndex = 0;

    for (let i = 1; i <= numLeaderPages; i++) {
        addPage(pages, `Leader Page ${i}`, 'Leader',pageNumber++,itemIndex,itemIndex+15);
        itemIndex = itemIndex + 16;
    }

    for (let i = 1; i <= numSpecialPages; i++) {
        addPage(pages, `Special Page ${i}`, 'Special',pageNumber++,i,i);
    }

    addPage(pages, 'VIP', 'VIP',pageNumber++);
    addPage(pages, 'AllStar', 'AllStar',pageNumber++);
    addPage(pages, 'Back', 'Back',pageNumber++);

    DetermineSheetIndex(pages);

    console.log(`Page Definition`);
    console.log(pages);

    return pages;

}

function addPage(pages: Page[], title: string, type: string, pageNumber:number, startIndex?: number, stopIndex?: number) {
    pages.push({
        title: title,
        type: type,
        pageNumber:pageNumber,
        startIndex: startIndex,
        stopIndex: stopIndex
    });
}

function DetermineSheetIndex(pages: Page[]){

    let sheetIndex = -1;
    let midPage = pages.length / 2;
    let addFactor = 0;

    console.log(`there are ${pages.length} pages`);
    console.log(`the midpage is ${midPage}`);
    
    for (let i = 0; i < pages.length; i++) {

        const pageNumber = pages[i].pageNumber;
        const isEven = (pageNumber % 2 === 0);
        if(pageNumber < midPage){
            addFactor = isEven ? 1 : 3;
        }
        else if (pageNumber == midPage || pageNumber == midPage+1){
            addFactor = 1;
        }
        else{
            addFactor = isEven ? -3 : -1;
        }

        sheetIndex = sheetIndex + addFactor;
        pages[i].sheetNumber = sheetIndex;
        
      
    }
}